// @ts-check
import BlockCard from '../BlockCard';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Keyed by state name (the API sends ending_soon, live or upcoming) so a colour never depends on which states are present.
const STATES = {
  ending_soon: { label: 'Ending soon', className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300' },
  live: { label: 'Live', className: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300' },
  upcoming: { label: 'Upcoming', className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300' },
};
const FALLBACK_STATE = { label: '', className: 'bg-muted text-muted-foreground' };

/** "2026-10-22" -> "22 Oct" without a Date (no timezone shift). */
function shortDate(iso) {
  const [, m, d] = String(iso).split('-');
  return `${Number(d)} ${MONTHS[Number(m) - 1] ?? ''}`.trim();
}

/** Compact list of live and upcoming sales events with their dates and a state tag. */
export default function SalesEventsBlock({ block }) {
  const { events = [] } = block.data || {};

  return (
    <BlockCard title="Sales events" href={block.href} headline={block.headline}>
      {events.length === 0 ? (
        <p className="text-sm text-muted-foreground">No live or upcoming sales events</p>
      ) : (
        <ul className="space-y-2">
          {events.map((e) => {
            const state = STATES[e.state] || { ...FALLBACK_STATE, label: String(e.state).replace(/_/g, ' ') };
            const dates = e.starts_on === e.ends_on ? shortDate(e.starts_on) : `${shortDate(e.starts_on)} – ${shortDate(e.ends_on)}`;
            return (
              <li key={`${e.name}-${e.starts_on}`} data-testid="sales-event" className="flex items-center justify-between gap-2 text-sm">
                <span className="min-w-0">
                  <span className="block truncate font-medium">{e.name}</span>
                  <span className="text-muted-foreground">{dates}</span>
                </span>
                <span data-testid="sales-event-state" data-state={e.state} className={`shrink-0 rounded px-2 py-0.5 text-xs font-medium ${state.className}`}>
                  {state.label}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </BlockCard>
  );
}
